import styled from 'styled-components'

import { Button as AntButton, Table as AntTable } from 'src/components/Ant'

export const Table = styled(AntTable)`
  border-radius: 4px;
`

export const Button = styled(AntButton)`
  margin-left: 0.5rem;
`
